import { render, staticRenderFns } from "./OutdoorDelivery.vue?vue&type=template&id=47984855&"
import script from "./OutdoorDelivery.vue?vue&type=script&lang=js&"
export * from "./OutdoorDelivery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/fwgcontao/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47984855')) {
      api.createRecord('47984855', component.options)
    } else {
      api.reload('47984855', component.options)
    }
    module.hot.accept("./OutdoorDelivery.vue?vue&type=template&id=47984855&", function () {
      api.rerender('47984855', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/fwgcontao/js/components/OutdoorDelivery.vue"
export default component.exports